export const typeColors = {
  factory: '#56C16C',
  sortie: '#F26C6D',
  exercise: '#9CD073',
  expedition: '#50C6C5',
  supply_repair: '#E2C873',
  arsenal: '#946B50',
  refurbishment: '#D5AEE2'
}

export const periodColors = {
  daily: '#71BFFD',
  weekly: '#74D4E0',
  monthly: '#B7E161',
  quarterly: '#DF9B61',
  yearly: '#FFFFFF',
  once: '#EED952'
}



// WEBPACK FOOTER //
// ./src/components/quest_modal/constants.js